import React from 'react';
import { connect } from 'react-redux';

class PlayIcon extends React.Component {

  render() {
    return (
      <svg>
        <g transform="matrix(0.0745098,0,0,0.0745098,1e-6,10e-7)"><path
         d="M 204,369.75 357,255 204,140.25 l 0,229.5 z M 255,0 C 114.75,0 0,114.75 0,255 0,395.25 114.75,510 255,510 395.25,510 510,395.25 510,255 510,114.75 395.25,0 255,0 Z m 0,459 C 142.8,459 51,367.2 51,255 51,142.8 142.8,51 255,51 c 112.2,0 204,91.8 204,204 0,112.2 -91.8,204 -204,204 z"
         id="path6"
       fill={this.props.color || "#DE171F"}
       /></g>
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(PlayIcon);



// WEBPACK FOOTER //
// ./src/icons/play.js